import { render, staticRenderFns } from "./EventModalParticipantPasses.vue?vue&type=template&id=55479ba0&scoped=true"
import script from "./EventModalParticipantPasses.vue?vue&type=script&lang=js"
export * from "./EventModalParticipantPasses.vue?vue&type=script&lang=js"
import style0 from "./EventModalParticipantPasses.vue?vue&type=style&index=0&id=55479ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55479ba0",
  null
  
)

export default component.exports